import type { IInstructionsData } from 'api/interfaces/instructions/interfaces.model'
import { ProgramFileIcon } from 'assets/img/logo/ProgramFile'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { pathENUM } from 'registrators/registrators'

import { pagesDataAPI } from '../../../../../axios/axios'
import { SLinkInstructions } from '../../MainMenu.styled'
import { SOrganisationInfo, STitle } from '../components.styled'

const testInstructions = [
  {
    title: 'Планирующим стать поставщиком ПФДО',
    href: '/docs/rostov/pfdo-provider-test.pdf',
  },
  {
    title: 'Присоединиться к АИС ЭДО',
    href: '/docs/rostov/join-ais-edo-test.pdf',
  },
]

export const InstructionsForOrganization = () => {
  const [instructionData, setInstructionData] = useState<IInstructionsData[]>(
    [],
  )

  const getInstructions = useCallback(async () => {
    try {
      const instructions = await pagesDataAPI.getInstructions()
      const { data } = instructions.data
      setInstructionData(data)
    } catch (e) {
      console.error(e)
    }
  }, [])

  useEffect(() => {
    getInstructions()
  }, [getInstructions])

  const instruction = useMemo(
    () =>
      instructionData
        .filter(
          ({ title }) =>
            !testInstructions.some(
              ({ title: testTitle }) => title === testTitle,
            ),
        )
        .map((instructions) => (
          <SLinkInstructions
            key={instructions.id}
            href={`${pathENUM.instructions}/${instructions.id}`}>
            <ProgramFileIcon />
            <STitle>{instructions.title}</STitle>
          </SLinkInstructions>
        )),
    [instructionData],
  )
  return (
    <SOrganisationInfo>
      Инструкции для организаций
      {testInstructions.map(({ title, href }) => (
        <SLinkInstructions
          key={href}
          href={href}
          target="_blank"
          rel="noreferrer">
          <ProgramFileIcon />
          <STitle>{title}</STitle>
        </SLinkInstructions>
      ))}
      {instruction}
    </SOrganisationInfo>
  )
}
